import { Controller } from "@hotwired/stimulus"

// Presentation only: Turbo owns the request, cancellation and frame rendering.
export default class extends Controller {
  static targets = ["frame"]

  connect() {
    this.placeholder = this.frameTarget.firstElementChild.cloneNode(true)
  }

  load() {
    if (!this.element.querySelector("dialog[open]")) return
    if (this.frameTarget.querySelector("[data-refresh-hold]")) return
    this.frameTarget.src = this.frameTarget.dataset.src
  }

  reset() {
    // Dismissal is not transaction cancellation. Keep pending/uncertain forms
    // connected, including their submit-once state and reconciliation action.
    if (this.frameTarget.querySelector("[data-refresh-hold]")) return
    this.frameTarget.removeAttribute("src")
    this.frameTarget.replaceChildren(this.placeholder.cloneNode(true))
    delete this.frameTarget.dataset.error
  }
}
